/* eslint-disable no-param-reassign */
import set from 'lodash/set';

import { NavigationListFilters } from '@lumapps/navigation/types';
import createSlice, { PayloadAction } from '@lumapps/redux/createSlice';

export interface NavigationAdminFiltersState {
    filters: NavigationListFilters;
    itemsAreFiltered: boolean;
    hideFilteredItems: boolean;
}

export const initialState: NavigationAdminFiltersState = {
    filters: {},
    itemsAreFiltered: false,
    hideFilteredItems: false,
};

const hasFilters = (state: NavigationAdminFiltersState) =>
    Object.values(state.filters).some((filtered) => Boolean(filtered));

export const reducers = {
    setFilters(state: NavigationAdminFiltersState, action: PayloadAction<NavigationListFilters>) {
        set(state, ['filters'], action.payload);
    },
    setFilter(
        state: NavigationAdminFiltersState,
        action: PayloadAction<{ filter: keyof NavigationListFilters; value: string }>,
    ) {
        const { filter, value } = action.payload;

        set(state, ['filters', filter], value);
        set(state, ['itemsAreFiltered'], hasFilters(state));
    },
    resetFilter(state: NavigationAdminFiltersState) {
        set(state, ['filters'], {});
        set(state, ['itemsAreFiltered'], false);
    },
    hideFilteredItems(state: NavigationAdminFiltersState, action: PayloadAction<boolean>) {
        set(state, ['hideFilteredItems'], action.payload);
    },
};

export type NavigationAdminFiltersActions = keyof typeof reducers;

export const { actions, reducer } = createSlice({
    domain: 'navigation-admin-filters',
    initialState,
    reducers,
});
